/* unplugin-vue-components disabled */import script from "./NavigationProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./NavigationProgressBar.vue?vue&type=style&index=0&id=5b3ed97c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b3ed97c"]])

export default __exports__